import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/AcsesLogsDashboard/components/AcsesLogsTable/components/AcsesResponseModal/AcsesResponseModal.scss";

type AcsesResponseModalProps = {
  responseContent: string;
  onClose: () => void;
};

export const AcsesResponseModal = ({ responseContent, onClose }: AcsesResponseModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={responseContent !== ""} className="AcsesResponseModal">
      <Modal.Header className="acses-response-modal-header">
        <span>{t("v8_response_content", "Response Content")}</span>
        <Button basic onClick={onClose} className="modal-close-btn">
          <Icon className="xmark" />
        </Button>
      </Modal.Header>
      <Modal.Content>{responseContent}</Modal.Content>
    </Modal>
  );
};
